<template>
  <div>
    <n-dialog-header
      :from="'testPaper'"
      :courseId="courseId"
      :subjectId="subjectId"
      :dialogVisible="dialogVisible"
      :chooseNum="chooseNum"
      @searchFunc="searchFunc"
      @changeCategory="changeCategory"
    ></n-dialog-header>
    <div class="main">
      <n-table
        ref="testpaper_table"
        v-loading="loading"
        :tableData="tableData"
        :tableHeader="TestPaperDialogTableHeader"
        :ISChangeCheckout="true"
        :TableHeight="'320px'"
        :key="keyT"
        @operation="operation"
      ></n-table>

      <Pagination
        :currentpage="pageTotal.currentPage"
        :limit="pageTotal.pageSize"
        :total="pageTotal.total"
        layout="total, sizes, prev, pager, next, jumper"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
        :small="true"
      ></Pagination>
    </div>
  </div>
</template>

<script>
import * as api from "../../../../../api/newCourseApi.js";
import * as testPaperApi from "../../../../../api/testPaperApi";
import nDialogHeader from "../../../components/n_dialog_header.vue";
import { TestPaperDialogTableHeader } from "../../../global/table_header_data";
import Pagination from "../../../../../components/paginator/paginator.vue";
export default {
  name: "addQuestion",
  components: {
    nDialogHeader,
    Pagination,
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    courseId: {
      type: [Number, String],
      default: "",
    },
    subjectId: {
      type: [Number, String],
      default: "",
    },
    isField: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      loading: false,
      TestPaperDialogTableHeader: TestPaperDialogTableHeader,
      searchParams: {
        categoryId: "", // 资源分类id
        name: "", // 资源名称
      },
      tableData: [],
      multipleSelection: [],
      chooseNum: 0,
      pageTotal: {
        //分页
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      keyT: 0
    };
  },
  created() {
    this.querytestPaperList();
  },
  mounted() {},
  watch: {
    dialogVisible: function (val) {
      if (val) {
        this.querytestPaperList();
      } else {
        this.emptyData();
      }
    },
  },
  methods: {
    // 查询list
    querytestPaperList() {
      this.loading = true;
      let params = {
        beginTime: null, //开始时间
        endTime: null, //结束时间
        // labelId: 6, //书证融通
        pageNo: this.pageTotal.currentPage, //当前页
        pageSize: this.pageTotal.pageSize, //每页个数
        paperName: this.searchParams.name, //试卷名称
        subjectId: this.subjectId, //科目id
        paperTypes:this.isField?[2]:[1, 2],
        status: 1,
        paperFrom: 0
      };
      // 修改为 资源库查询接口 （包括已加密的试卷）
      // testPaperApi
      //   .SelectTestPaPer(params)
      api
        .SelectTestPaPerByPaperType(params)
        .then((res) => {
          if (res.code == "0") {
            this.tableData = res.data.testPaperList;
            this.pageTotal.total = res.data.totalCount;

            this.$refs.testpaper_table.ClearData();
            this.multipleSelection = [];
            this.chooseNum = 0;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(()=>{
          this.loading = false;
        })
    },
    handleCurrentChange(val) {
      this.pageTotal.currentPage = val;
      // this.$refs.question_testArea.scrollTop = 0;
      this.querytestPaperList();
    },
    handleSizeChange(val) {
      this.pageTotal.pageSize = val;
      this.pageTotal.currentPage = 1;
      // this.$refs.question_testArea.scrollTop = 0;
      this.querytestPaperList();
    },
    operation(type, RowData) {
      if (type == "selectChange") {
        // 选中
        this.multipleSelection = RowData;
        this.chooseNum = this.multipleSelection.length;
      } else if (type == "preview") {
        console.log("preview");
      } else if (type == "delete") {
        console.log("delete");
      }
    },
    emptyData() {
      this.searchParams = {
        categoryId: "", // 资源分类id
        name: "", // 资源名称
      };
      this.pageTotal = {
        //分页
        currentPage: 1,
        pageSize: 10,
        total: 0,
      };
      this.tableData = [];
      this.multipleSelection = [];
      this.chooseNum = 0;
      this.keyT++;
    },
    searchFunc(param) {
      this.pageTotal.currentPage = 1;
      this.searchParams.name = param.name;
      this.querytestPaperList();
    },
    changeCategory(id) {
      this.searchParams.categoryId = id;
    }
  },
};
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/new_course_module/editCourse/testPaper/addTestPaper.vue